import React from 'react';
import PropTypes from 'prop-types';

import BorderlessButton from '../../../../common/buttons/BorderlessButton';
import { getUnassignedPillStyles } from './timeTrackingGridHelpers';
import { showRegularHours, showOTHours, showDoubleOTHours } from './timeTrackingGrid.constants';

const UNASSIGNED_USER_HOUR_TYPES = [
  { key: 'hours', show: showRegularHours },
  { key: 'otHours', show: showOTHours },
  { key: 'doubleOTHours', show: showDoubleOTHours },
];

export default function UnassignedUserPills({
  relevantData,
  selectedView,
  responding,
  compact,
  onPress,
}) {
  const wrapClassName = [
    'ttg-unassigned-cell-wrap',
    'ttg-unassigned-cell-wrap-unassigned',
    compact && 'ttg-unassigned-cell-wrap-compact',
  ].filter(Boolean).join(' ');

  const columnClassName = [
    'ttg-unassigned-pill-column',
    compact && 'ttg-unassigned-pill-column-compact',
  ].filter(Boolean).join(' ');

  const rowClassName = [
    'ttg-unassigned-pill-row',
    compact && 'ttg-unassigned-pill-row-compact',
  ].filter(Boolean).join(' ');

  const pills = UNASSIGNED_USER_HOUR_TYPES
    .filter(({ show }) => show(selectedView))
    .map(({ key }) => {
      const { label, pillClassName, pillTextClassName } = getUnassignedPillStyles(relevantData?.[key]);
      return (
        <div key={key} className={rowClassName}>
          <div
            className={[
              pillClassName,
              !responding && 'ttg-unassigned-pill-readonly',
            ].filter(Boolean).join(' ')}
          >
            <span className={pillTextClassName}>{label}</span>
          </div>
        </div>
      );
    });

  if (!responding) {
    return (
      <div className={wrapClassName}>
        <div className={columnClassName}>{pills}</div>
      </div>
    );
  }

  return (
    <div className={wrapClassName}>
      <BorderlessButton
        className={`${columnClassName} ttg-unassigned-pill-button`}
        iconLeft
        iconNode={pills}
        onClick={onPress}
        style={{ width: '100%', height: 'auto', padding: 0 }}
      />
    </div>
  );
}

UnassignedUserPills.propTypes = {
  relevantData: PropTypes.object.isRequired,
  selectedView: PropTypes.string.isRequired,
  responding: PropTypes.bool.isRequired,
  compact: PropTypes.bool.isRequired,
  onPress: PropTypes.func.isRequired,
};
